export default __webpack_public_path__ + "media/images/masto-journée-droits-des-femmes-223c643827de21c84476d496f6a09ec6.png";